import ThumbsDownFilledIcon from './Thumbs/ThumbsDownFilledIcon';
import ThumbsDownIcon from './Thumbs/ThumbsDownIcon';
import ThumbsUpFilledIcon from './Thumbs/ThumbsUpFilledIcon';
import ThumbsUpIcon from './Thumbs/ThumbsUpIcon';

export const THUMB_STATE = {
  UP: 'up',
  DOWN: 'down',
};

export const MAP_THUMB_STATE_TO_ICON = {
  [THUMB_STATE.UP]: ThumbsUpIcon,
  [THUMB_STATE.DOWN]: ThumbsDownIcon,
  [`${THUMB_STATE.UP}_filled`]: ThumbsUpFilledIcon,
  [`${THUMB_STATE.DOWN}_filled`]: ThumbsDownFilledIcon,
};
